import { RevPopover } from '@ds/components/Popover'
import { RevTooltip } from '@ds/components/Tooltip'
import isEmpty from 'lodash/isEmpty'
import { computed } from 'vue'

import { getPlugin as getTranslationPlugin } from '@i18n/utils'

import { paymentGroupConfig } from '..'


export default {
  __name: 'PaymentMethodsErrors',
  props: {
  paymentMethods: {
    type: Array,
    required: true,
  },

  innerClass: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props



const $t = getTranslationPlugin()

// Create a dictionary indexed by error code, to avoid repeating twice the same error.
const paymentGroupIdsByErrorCode = computed(() =>
  props.paymentMethods.reduce(
    (acc1, paymentMethod) => ({
      ...paymentMethod.errors.reduce(
        (acc2, errorCode) => ({ ...acc2, [errorCode]: paymentMethod.group }),
        {},
      ),
      ...acc1,
    }),
    {},
  ),
)

const errorMessages = computed(() =>
  Object.entries(paymentGroupIdsByErrorCode.value).map(
    ([errorCode, paymentGroupId]) => {
      const methods = props.paymentMethods
      const groupConfig = paymentGroupConfig(paymentGroupId, { methods })
      const translation = groupConfig?.errorMessages?.[errorCode]

      return translation ? $t(translation) : errorCode
    },
  ),
)

const hasErrors = computed(() => !isEmpty(errorMessages.value))

const tabIndex = computed(() => (hasErrors.value ? '0' : '-1'))

return { __sfc: true,props, $t, paymentGroupIdsByErrorCode, errorMessages, hasErrors, tabIndex, RevPopover, RevTooltip }
}

}